export const platformCopy = {
  en: {
    workflows: 'Workflows',
    connectors: 'Connectors',
    advanced: 'Advanced settings',
    clients: 'Agency clients',
    directory:
      'Manage independent client workspaces. Linking a client does not grant access to their content.',
    create: 'Create',
    name: 'Name',
    slug: 'Workspace address',
    link: 'Link existing workspace',
    tenantId: 'Workspace ID',
    switch: 'Open workspace',
    noAccess: 'Separate membership required',
    unlink: 'Unlink',
    empty: 'No items yet',
    save: 'Save draft',
    publish: 'Publish',
    pause: 'Pause',
    resume: 'Enable',
    restore: 'Restore version',
    test: 'Test connection',
    disable: 'Disable',
    reconnect: 'Reconnect',
    status: 'Status',
    capabilities: 'Allowed actions',
    connectionsDescription:
      'Connect business systems and choose the actions your agents may use. Changes still require tool grants and customer authorization.',
    baseUrl: 'WHMCS HTTPS address',
    identifier: 'API identifier',
    secret: 'API secret',
    tools: 'MCP and HTTP tools',
    agents: 'External agents',
    credentials: 'Credentials stay on the server. Never paste customer passwords.',
    workflowDescription:
      'Build bounded steps, publish a version, and follow each run. Approval steps wait for an authorized person.',
    addStep: 'Add step',
    remove: 'Remove',
    type: 'Step type',
    next: 'Next step',
    seconds: 'Wait seconds',
    query: 'Knowledge question',
    reason: 'Handoff reason',
    field: 'Customer field',
    value: 'Match value',
    otherwise: 'Otherwise',
    toolId: 'Tool ID',
    arguments: 'Action arguments (JSON)',
    request: 'Delegation request',
    connectionId: 'Agent connection ID',
    runs: 'Recent runs',
    cancel: 'Cancel run',
    trigger: 'Start when',
    versions: 'Versions',
    unsaved: 'Save changes before publishing.',
    setup: 'Setup checklist',
    useCase: 'Choose your use case',
    knowledge: 'Add approved knowledge',
    permissions: 'Connect systems and review permissions',
    testPublish: 'Test, publish and install',
    support: 'Customer support',
    lead: 'Lead capture',
    billing: 'Billing help',
    service: 'Service changes',
    afterhours: 'After hours',
    handoff: 'Human handoff',
    notReady:
      'Checklist progress is not a live-readiness guarantee. Verify knowledge, permissions and a successful test before publishing.',
    livePreview: 'Open real widget preview',
    font: 'Typography',
    launcher: 'Launcher label',
    invalidJson: 'Enter a JSON object.',
    coordinator: 'Coordinator agent',
    operator: 'Comparison',
    yes: 'Yes',
    no: 'No',
    entry: 'First step',
    budgets: 'Run limits',
    conversationId: 'Conversation ID',
    startRun: 'Start run',
    draft: 'Draft',
    unsavedChanges: 'Unpublished changes',
    identityKeyId: 'Verified identity key ID',
    permissionTest:
      'Review permissions in Tools before enabling an agent. Test actions with the same role and customer identity used in production.',
    endpoint: 'HTTPS agent endpoint',
    credentialSecretId: 'Credential secret ID (optional)',
    showBranding: 'Show Hamnivo branding',
    previewSaved: 'Preview uses the last saved settings and creates test conversations.',
    checkUnknown: 'Not checked',
    checkPresent: 'Configured',
    checkMissing: 'Needs setup',
    publishedAgent: 'Published default agent',
    template: 'Starting template',
    delegateAllowlist: 'Allowed internal specialists',
    whenMatched: 'When matched',
    branding: 'Branding',
    brandingDescription: 'Customize your portal, customer emails and verified portal domains.',
    portal: 'Portal appearance',
    favicon: 'Favicon HTTPS URL',
    customerEmail: 'Customer email appearance',
    emailLimits:
      'These settings change the sender name, reply address and logo. The platform sending address stays in use.',
    senderName: 'Sender display name',
    replyTo: 'Reply-to email address',
    saveBranding: 'Save branding',
    brandingSaved: 'Branding saved',
    domains: 'Portal domains',
    domainReadiness:
      'Add the TXT record at your DNS provider. Ownership verification, approved routing and TLS must all be ready before a domain becomes active.',
    dnsName: 'TXT record name',
    dnsValue: 'TXT record value',
    routing: 'Routing ready',
    verify: 'Verify DNS',
    hostname: 'Portal hostname',
    addDomain: 'Add portal domain',
    customAuth:
      'Use email and password on this portal. Passkeys and single sign-on use your canonical portal address.',
    aiUsage: 'AI usage',
    managedTokens: 'Managed tokens used',
    reservedTokens: 'Managed tokens reserved',
    managedCredits: 'Managed AI credits',
    byokTokens: 'Your-key tokens',
    creditNote:
      'Credits are internal usage units, not currency. Calls using your own provider key are tracked separately. Reserved usage may await a provider receipt.',
    appearanceDraftSaved: 'Appearance draft saved. Customers still see the published appearance.',
    appearancePublished: 'Widget appearance published',
    advancedDefinition: 'Advanced workflow definition (JSON)',
    applyDefinition: 'Apply definition',
    bindingsHint:
      'Reference previous step results with queryFrom, requestFrom or action bindings. Apply the definition before saving; the server validates every reference and permission.',
    stepResult: 'Step result',
    untrustedResult:
      'Retrieved and delegated content is untrusted data. It cannot grant permissions or change policy.',
    specialistAgentId: 'Internal specialist agent ID',
    agencyDisabled:
      'Agency mode is off. Enable it to create or link independent client workspaces with their own memberships.',
    enableAgency: 'Enable agency mode',
    chatRoute: 'Chat channel',
    permissionPreview: 'Test WHMCS user permissions',
    permissionPreviewHint:
      'Checks live access for this WHMCS user and client account. This check reads permissions and does not run business actions.',
    whmcsUser: 'WHMCS user ID',
    whmcsClient: 'WHMCS client ID',
    checkPermissions: 'Check permissions',
    permissionsVerified: 'Live permissions verified. Review each action below.',
    permissionsUnverified: 'Could not verify live permissions. No access is assumed.',
    livePreviewNote:
      'This is a real test chat. Draft changes appear here; customers see the published appearance. Availability comes from the live chat service.',
    closeLivePreview: 'Show picture preview',
    actionTool: 'Action tool',
    specialist: 'Specialist',
    internalSpecialist: 'Internal agent',
    externalSpecialist: 'External connection',
    unavailableTool: 'Unavailable tool (saved selection)',
    unavailableSpecialist: 'Unavailable specialist (saved selection)',
    resourcePickerHint:
      'Shows resources for this brand that your role may read. Saved unavailable choices remain visible for review.',
    resultPredicateHint:
      'This condition compares a previous step result. Edit its source and comparison in Advanced workflow definition; the basic editor preserves it.',
    manualCoordinatorHint: 'Manual runs may use any active, published agent for this brand.',
    automaticCoordinatorHint:
      'Automatic workflows require this brand’s active, published default reply agent.',
    unavailableCoordinator: 'Unavailable coordinator (saved selection)',
    stepTypes: {
      trigger: 'Start',
      condition: 'Branch',
      branch: 'Branch',
      knowledge_lookup: 'Search knowledge',
      tool_action: 'Run an action',
      approval: 'Request approval',
      wait: 'Wait',
      delegate: 'Delegate to specialist',
      handoff: 'Hand off to staff',
    },
    fields: {
      event: 'Event',
      hours_open: 'Within business hours',
      signed_in: 'Customer signed in',
      country: 'Country',
      language: 'Language',
      tag: 'Tag',
    },
    operators: { is: 'Is', is_not: 'Is not', contains: 'Contains' },
    budget: {
      maxSteps: 'Maximum steps',
      maxDelegations: 'Maximum delegations',
      maxDurationSeconds: 'Maximum duration (seconds)',
      maxDepth: 'Maximum delegation depth',
    },
    triggers: {
      manual: 'Manually',
      chat_started: 'Chat starts',
      customer_message: 'Customer sends a message',
      chat_closed: 'Chat closes',
      offline_message: 'Offline message',
    },
    runStates: {
      queued: 'Queued',
      running: 'Running',
      waiting: 'Waiting',
      awaiting_approval: 'Awaiting approval',
      completed: 'Completed',
      cancelled: 'Cancelled',
      handed_off: 'Handed to staff',
      failed: 'Failed',
      unknown: 'Needs review',
    },
    risks: {
      read: 'Read information',
      write: 'Changes information',
      money: 'Financial action',
      irreversible: 'Cannot be undone',
    },
    approvers: { customer: 'Customer approval', staff: 'Staff approval' },
    connectionStates: { active: 'Active', disabled: 'Disabled' },
    domainStates: {
      pending: 'Pending verification',
      verified: 'Ownership verified',
      active: 'Active',
      disabled: 'Disabled',
    },
    domainChecks: {
      verified: 'DNS record verified',
      not_found: 'TXT record not found',
      lookup_failed: 'DNS lookup failed; try again',
    },
    permissionReasons: {
      allowed: 'Allowed',
      grant_disabled: 'Action not granted',
      connection_disabled: 'Connection disabled',
      permission_denied: 'User permission denied',
      permission_unverified: 'Permission unverified',
    },
  },
  hi: {
    workflows: 'वर्कफ़्लो',
    connectors: 'कनेक्टर',
    advanced: 'उन्नत सेटिंग',
    clients: 'एजेंसी क्लाइंट',
    directory: 'स्वतंत्र क्लाइंट कार्यस्थान प्रबंधित करें। लिंक करने से सामग्री की अनुमति नहीं मिलती।',
    create: 'बनाएँ',
    name: 'नाम',
    slug: 'कार्यस्थान पता',
    link: 'मौजूदा कार्यस्थान जोड़ें',
    tenantId: 'कार्यस्थान आईडी',
    switch: 'कार्यस्थान खोलें',
    noAccess: 'अलग सदस्यता आवश्यक',
    unlink: 'लिंक हटाएँ',
    empty: 'अभी कोई आइटम नहीं',
    save: 'ड्राफ़्ट सहेजें',
    publish: 'प्रकाशित करें',
    pause: 'रोकें',
    resume: 'सक्रिय करें',
    restore: 'संस्करण बहाल करें',
    test: 'कनेक्शन जाँचें',
    disable: 'बंद करें',
    reconnect: 'फिर जोड़ें',
    status: 'स्थिति',
    capabilities: 'अनुमत कार्रवाइयाँ',
    connectionsDescription:
      'व्यावसायिक सिस्टम जोड़ें और एजेंट की कार्रवाइयाँ चुनें। टूल अनुमति और ग्राहक प्राधिकरण अभी भी आवश्यक हैं।',
    baseUrl: 'WHMCS HTTPS पता',
    identifier: 'एपीआई पहचानकर्ता',
    secret: 'एपीआई सीक्रेट',
    tools: 'MCP और HTTP टूल',
    agents: 'बाहरी एजेंट',
    credentials: 'क्रेडेंशियल सर्वर पर रहते हैं। ग्राहक के पासवर्ड न डालें।',
    workflowDescription:
      'सीमित चरण बनाएँ, संस्करण प्रकाशित करें और हर रन देखें। अनुमोदन चरण अधिकृत व्यक्ति की प्रतीक्षा करते हैं।',
    addStep: 'चरण जोड़ें',
    remove: 'हटाएँ',
    type: 'चरण प्रकार',
    next: 'अगला चरण',
    seconds: 'प्रतीक्षा सेकंड',
    query: 'ज्ञान प्रश्न',
    reason: 'हैंडऑफ़ कारण',
    field: 'ग्राहक फ़ील्ड',
    value: 'मिलान मान',
    otherwise: 'अन्यथा',
    toolId: 'टूल आईडी',
    arguments: 'कार्रवाई आर्ग्युमेंट (JSON)',
    request: 'प्रत्यायोजन अनुरोध',
    connectionId: 'एजेंट कनेक्शन आईडी',
    runs: 'हाल के रन',
    cancel: 'रन रद्द करें',
    trigger: 'शुरू होने का समय',
    versions: 'संस्करण',
    unsaved: 'प्रकाशित करने से पहले सहेजें।',
    setup: 'सेटअप जाँचसूची',
    useCase: 'उपयोग चुनें',
    knowledge: 'स्वीकृत ज्ञान जोड़ें',
    permissions: 'सिस्टम जोड़ें और अनुमतियाँ जाँचें',
    testPublish: 'जाँचें, प्रकाशित और इंस्टॉल करें',
    support: 'ग्राहक सहायता',
    lead: 'लीड संग्रह',
    billing: 'बिलिंग सहायता',
    service: 'सेवा बदलाव',
    afterhours: 'काम के बाद',
    handoff: 'मानव सहायता',
    notReady:
      'जाँचसूची की प्रगति लाइव तैयारी की गारंटी नहीं है। प्रकाशित करने से पहले ज्ञान, अनुमतियाँ और सफल जाँच सत्यापित करें।',
    livePreview: 'असली विजेट पूर्वावलोकन खोलें',
    font: 'टाइपोग्राफ़ी',
    launcher: 'लॉन्चर लेबल',
    invalidJson: 'JSON ऑब्जेक्ट दर्ज करें।',
    coordinator: 'समन्वयक एजेंट',
    operator: 'तुलना',
    yes: 'हाँ',
    no: 'नहीं',
    entry: 'पहला चरण',
    budgets: 'रन सीमाएँ',
    conversationId: 'बातचीत आईडी',
    startRun: 'रन शुरू करें',
    draft: 'ड्राफ़्ट',
    unsavedChanges: 'अप्रकाशित बदलाव',
    identityKeyId: 'सत्यापित पहचान कुंजी आईडी',
    permissionTest: 'एजेंट चालू करने से पहले टूल में अनुमतियाँ जाँचें। प्रोडक्शन वाली भूमिका और ग्राहक पहचान से जाँचें।',
    endpoint: 'HTTPS एजेंट एंडपॉइंट',
    credentialSecretId: 'क्रेडेंशियल सीक्रेट आईडी (वैकल्पिक)',
    showBranding: 'Hamnivo ब्रांडिंग दिखाएँ',
    previewSaved: 'पूर्वावलोकन सहेजी सेटिंग इस्तेमाल करता है और परीक्षण बातचीत बनाता है।',
    checkUnknown: 'जाँचा नहीं',
    checkPresent: 'कॉन्फ़िगर किया गया',
    checkMissing: 'सेटअप आवश्यक',
    publishedAgent: 'प्रकाशित डिफ़ॉल्ट एजेंट',
    template: 'शुरुआती टेम्पलेट',
    delegateAllowlist: 'अनुमत आंतरिक विशेषज्ञ',
    whenMatched: 'मिलने पर',
    branding: 'ब्रांडिंग',
    brandingDescription: 'पोर्टल, ग्राहक ईमेल और सत्यापित डोमेन अनुकूलित करें।',
    portal: 'पोर्टल रूप',
    favicon: 'फ़ेविकॉन HTTPS URL',
    customerEmail: 'ग्राहक ईमेल रूप',
    emailLimits: 'ये सेटिंग प्रेषक का नाम, उत्तर पता और लोगो बदलती हैं। प्लेटफ़ॉर्म भेजने का पता इस्तेमाल होता है।',
    senderName: 'प्रेषक नाम',
    replyTo: 'उत्तर ईमेल पता',
    saveBranding: 'ब्रांडिंग सहेजें',
    brandingSaved: 'ब्रांडिंग सहेजी गई',
    domains: 'पोर्टल डोमेन',
    domainReadiness:
      'DNS प्रदाता पर TXT रिकॉर्ड जोड़ें। डोमेन सक्रिय होने से पहले स्वामित्व, स्वीकृत रूटिंग और TLS तैयार होने चाहिए।',
    dnsName: 'TXT रिकॉर्ड नाम',
    dnsValue: 'TXT रिकॉर्ड मान',
    routing: 'रूटिंग तैयार',
    verify: 'DNS सत्यापित करें',
    hostname: 'पोर्टल होस्टनाम',
    addDomain: 'पोर्टल डोमेन जोड़ें',
    customAuth:
      'इस पोर्टल पर ईमेल और पासवर्ड का उपयोग करें। पासकी और सिंगल साइन-ऑन के लिए मुख्य पोर्टल पता इस्तेमाल करें।',
    aiUsage: 'AI उपयोग',
    managedTokens: 'प्रबंधित टोकन उपयोग',
    reservedTokens: 'प्रबंधित आरक्षित टोकन',
    managedCredits: 'प्रबंधित AI क्रेडिट',
    byokTokens: 'आपकी कुंजी के टोकन',
    creditNote:
      'क्रेडिट आंतरिक उपयोग इकाइयाँ हैं, मुद्रा नहीं। अपनी प्रदाता कुंजी के कॉल अलग गिने जाते हैं। आरक्षित उपयोग प्रदाता रसीद की प्रतीक्षा कर सकता है।',
    appearanceDraftSaved: 'रूप का ड्राफ़्ट सहेजा गया। ग्राहक प्रकाशित रूप देखते हैं।',
    appearancePublished: 'विजेट रूप प्रकाशित',
    advancedDefinition: 'उन्नत वर्कफ़्लो परिभाषा (JSON)',
    applyDefinition: 'परिभाषा लागू करें',
    bindingsHint:
      'queryFrom, requestFrom या कार्रवाई बाइंडिंग से पिछले चरण के परिणाम लें। सहेजने से पहले परिभाषा लागू करें; सर्वर संदर्भ और अनुमति जाँचता है।',
    stepResult: 'चरण परिणाम',
    untrustedResult: 'प्राप्त और सौंपा गया सामग्री अविश्वसनीय डेटा है। यह अनुमतियाँ या नीति नहीं बदल सकता।',
    specialistAgentId: 'आंतरिक विशेषज्ञ एजेंट आईडी',
    agencyDisabled:
      'एजेंसी मोड बंद है। अपनी सदस्यता वाले स्वतंत्र क्लाइंट कार्यस्थान बनाने या जोड़ने के लिए सक्रिय करें।',
    enableAgency: 'एजेंसी मोड सक्रिय करें',
    chatRoute: 'चैट चैनल',
    permissionPreview: 'WHMCS उपयोगकर्ता अनुमतियाँ जाँचें',
    permissionPreviewHint:
      'इस WHMCS उपयोगकर्ता और क्लाइंट खाते की मौजूदा पहुँच जाँचें। यह अनुमति पढ़ता है और व्यावसायिक कार्रवाइयाँ नहीं चलाता।',
    whmcsUser: 'WHMCS उपयोगकर्ता आईडी',
    whmcsClient: 'WHMCS क्लाइंट आईडी',
    checkPermissions: 'अनुमतियाँ जाँचें',
    permissionsVerified: 'मौजूदा अनुमतियाँ सत्यापित। हर कार्रवाई नीचे देखें।',
    permissionsUnverified: 'मौजूदा अनुमतियाँ सत्यापित नहीं हुईं। पहुँच नहीं मानी जाती।',
    livePreviewNote:
      'यह असली परीक्षण चैट है। ड्राफ़्ट बदलाव यहाँ दिखते हैं; ग्राहक प्रकाशित रूप देखते हैं। उपलब्धता लाइव चैट सेवा से आती है।',
    closeLivePreview: 'चित्र पूर्वावलोकन दिखाएँ',
    actionTool: 'कार्रवाई टूल',
    specialist: 'विशेषज्ञ',
    internalSpecialist: 'आंतरिक एजेंट',
    externalSpecialist: 'बाहरी कनेक्शन',
    unavailableTool: 'टूल उपलब्ध नहीं (सहेजा चयन)',
    unavailableSpecialist: 'विशेषज्ञ उपलब्ध नहीं (सहेजा चयन)',
    resourcePickerHint:
      'इस ब्रांड के वे संसाधन दिखते हैं जिन्हें आपकी भूमिका पढ़ सकती है। अनुपलब्ध सहेजे चयन समीक्षा के लिए दिखाई देते हैं।',
    resultPredicateHint:
      'यह शर्त पिछले चरण के परिणाम की तुलना करती है। स्रोत और तुलना उन्नत वर्कफ़्लो परिभाषा में संपादित करें; मूल संपादक इसे सुरक्षित रखता है।',
    manualCoordinatorHint: 'मैन्युअल रन इस ब्रांड के किसी सक्रिय, प्रकाशित एजेंट का उपयोग कर सकते हैं।',
    automaticCoordinatorHint: 'स्वचालित वर्कफ़्लो को इस ब्रांड का सक्रिय, प्रकाशित डिफ़ॉल्ट उत्तर एजेंट चाहिए।',
    unavailableCoordinator: 'समन्वयक उपलब्ध नहीं (सहेजा चयन)',
    stepTypes: {
      trigger: 'आरंभ',
      condition: 'शाखा',
      branch: 'शाखा',
      knowledge_lookup: 'ज्ञान खोजें',
      tool_action: 'कार्रवाई चलाएँ',
      approval: 'अनुमोदन माँगें',
      wait: 'प्रतीक्षा',
      delegate: 'विशेषज्ञ को सौंपें',
      handoff: 'कर्मचारी को सौंपें',
    },
    fields: {
      event: 'ईवेंट',
      hours_open: 'कार्य समय में',
      signed_in: 'ग्राहक साइन इन',
      country: 'देश',
      language: 'भाषा',
      tag: 'टैग',
    },
    operators: { is: 'है', is_not: 'नहीं है', contains: 'शामिल है' },
    budget: {
      maxSteps: 'अधिकतम चरण',
      maxDelegations: 'अधिकतम प्रत्यायोजन',
      maxDurationSeconds: 'अधिकतम अवधि (सेकंड)',
      maxDepth: 'अधिकतम प्रत्यायोजन गहराई',
    },
    triggers: {
      manual: 'मैन्युअल',
      chat_started: 'चैट शुरू',
      customer_message: 'ग्राहक संदेश भेजे',
      chat_closed: 'चैट बंद',
      offline_message: 'ऑफ़लाइन संदेश',
    },
    runStates: {
      queued: 'कतार में',
      running: 'चल रहा',
      waiting: 'प्रतीक्षा',
      awaiting_approval: 'अनुमोदन की प्रतीक्षा',
      completed: 'पूरा',
      cancelled: 'रद्द',
      handed_off: 'कर्मचारी को सौंपा',
      failed: 'विफल',
      unknown: 'समीक्षा आवश्यक',
    },
    risks: {
      read: 'जानकारी पढ़ें',
      write: 'जानकारी बदलता है',
      money: 'वित्तीय कार्रवाई',
      irreversible: 'वापस नहीं हो सकता',
    },
    approvers: { customer: 'ग्राहक अनुमोदन', staff: 'कर्मचारी अनुमोदन' },
    connectionStates: { active: 'सक्रिय', disabled: 'बंद' },
    domainStates: {
      pending: 'सत्यापन लंबित',
      verified: 'स्वामित्व सत्यापित',
      active: 'सक्रिय',
      disabled: 'बंद',
    },
    domainChecks: {
      verified: 'DNS रिकॉर्ड सत्यापित',
      not_found: 'TXT रिकॉर्ड नहीं मिला',
      lookup_failed: 'DNS जाँच विफल; फिर कोशिश करें',
    },
    permissionReasons: {
      allowed: 'अनुमत',
      grant_disabled: 'कार्रवाई की अनुमति नहीं',
      connection_disabled: 'कनेक्शन बंद',
      permission_denied: 'उपयोगकर्ता अनुमति अस्वीकृत',
      permission_unverified: 'अनुमति असत्यापित',
    },
  },
  ur: {
    workflows: 'ورک فلو',
    connectors: 'کنیکٹرز',
    advanced: 'اعلیٰ ترتیبات',
    clients: 'ایجنسی کلائنٹس',
    directory: 'آزاد کلائنٹ ورک اسپیس کا نظم کریں۔ لنک کرنے سے مواد تک رسائی نہیں ملتی۔',
    create: 'بنائیں',
    name: 'نام',
    slug: 'ورک اسپیس پتہ',
    link: 'موجودہ ورک اسپیس لنک کریں',
    tenantId: 'ورک اسپیس شناخت',
    switch: 'ورک اسپیس کھولیں',
    noAccess: 'علیحدہ رکنیت ضروری',
    unlink: 'لنک ہٹائیں',
    empty: 'ابھی کوئی آئٹم نہیں',
    save: 'مسودہ محفوظ کریں',
    publish: 'شائع کریں',
    pause: 'روکیں',
    resume: 'فعال کریں',
    restore: 'ورژن بحال کریں',
    test: 'کنکشن آزمائیں',
    disable: 'غیر فعال کریں',
    reconnect: 'دوبارہ جوڑیں',
    status: 'حالت',
    capabilities: 'اجازت یافتہ کارروائیاں',
    connectionsDescription:
      'کاروباری سسٹم جوڑیں اور ایجنٹ کی کارروائیاں منتخب کریں۔ ٹول کی اجازت اور صارف کی تصدیق پھر بھی ضروری ہے۔',
    baseUrl: 'WHMCS HTTPS پتہ',
    identifier: 'API شناخت',
    secret: 'API خفیہ کلید',
    tools: 'MCP اور HTTP ٹولز',
    agents: 'بیرونی ایجنٹس',
    credentials: 'اسناد سرور پر رہتی ہیں۔ صارف کے پاس ورڈ مت ڈالیں۔',
    workflowDescription:
      'محدود مراحل بنائیں، ورژن شائع کریں اور ہر اجرا دیکھیں۔ منظوری کے مراحل مجاز فرد کا انتظار کرتے ہیں۔',
    addStep: 'مرحلہ شامل کریں',
    remove: 'ہٹائیں',
    type: 'مرحلے کی قسم',
    next: 'اگلا مرحلہ',
    seconds: 'انتظار کے سیکنڈ',
    query: 'معلوماتی سوال',
    reason: 'منتقلی کی وجہ',
    field: 'صارف فیلڈ',
    value: 'مماثل قدر',
    otherwise: 'بصورت دیگر',
    toolId: 'ٹول شناخت',
    arguments: 'کارروائی دلائل (JSON)',
    request: 'تفویض کی درخواست',
    connectionId: 'ایجنٹ کنکشن شناخت',
    runs: 'حالیہ اجرا',
    cancel: 'اجرا منسوخ کریں',
    trigger: 'شروع ہونے کی شرط',
    versions: 'ورژنز',
    unsaved: 'شائع کرنے سے پہلے محفوظ کریں۔',
    setup: 'سیٹ اپ فہرست',
    useCase: 'استعمال منتخب کریں',
    knowledge: 'منظور شدہ معلومات شامل کریں',
    permissions: 'سسٹم جوڑیں اور اجازتیں دیکھیں',
    testPublish: 'آزمائیں، شائع اور نصب کریں',
    support: 'کسٹمر سپورٹ',
    lead: 'لیڈ حاصل کریں',
    billing: 'بلنگ مدد',
    service: 'سروس تبدیلیاں',
    afterhours: 'اوقات کے بعد',
    handoff: 'انسان کو منتقلی',
    notReady:
      'فہرست کی پیش رفت لائیو تیاری کی ضمانت نہیں۔ شائع کرنے سے پہلے معلومات، اجازتیں اور کامیاب ٹیسٹ کی تصدیق کریں۔',
    livePreview: 'اصل ویجٹ کا پیش منظر کھولیں',
    font: 'خط',
    launcher: 'لانچر عبارت',
    invalidJson: 'JSON آبجیکٹ درج کریں۔',
    coordinator: 'رابطہ کار ایجنٹ',
    operator: 'موازنہ',
    yes: 'ہاں',
    no: 'نہیں',
    entry: 'پہلا مرحلہ',
    budgets: 'اجرا کی حدود',
    conversationId: 'گفتگو شناخت',
    startRun: 'اجرا شروع کریں',
    draft: 'مسودہ',
    unsavedChanges: 'غیر شائع شدہ تبدیلیاں',
    identityKeyId: 'تصدیق شدہ شناختی کلید',
    permissionTest:
      'ایجنٹ فعال کرنے سے پہلے ٹولز میں اجازتیں دیکھیں۔ اصل کردار اور صارف شناخت سے آزمائیں۔',
    endpoint: 'HTTPS ایجنٹ اینڈ پوائنٹ',
    credentialSecretId: 'اسناد کی خفیہ شناخت (اختیاری)',
    showBranding: 'Hamnivo برانڈنگ دکھائیں',
    previewSaved: 'پیش منظر محفوظ ترتیبات استعمال کرتا ہے اور آزمائشی گفتگو بناتا ہے۔',
    checkUnknown: 'جانچا نہیں',
    checkPresent: 'ترتیب دیا گیا',
    checkMissing: 'سیٹ اپ ضروری',
    publishedAgent: 'شائع شدہ ڈیفالٹ ایجنٹ',
    template: 'ابتدائی سانچہ',
    delegateAllowlist: 'اجازت یافتہ داخلی ماہرین',
    whenMatched: 'مماثلت پر',
    branding: 'برانڈنگ',
    brandingDescription: 'پورٹل، صارف ای میل اور تصدیق شدہ ڈومین ترتیب دیں۔',
    portal: 'پورٹل کا انداز',
    favicon: 'فیویکون HTTPS URL',
    customerEmail: 'صارف ای میل کا انداز',
    emailLimits:
      'یہ ترتیبات بھیجنے والے کا نام، جواب کا پتہ اور لوگو بدلتی ہیں۔ پلیٹ فارم کا بھیجنے کا پتہ استعمال ہوتا ہے۔',
    senderName: 'بھیجنے والے کا نام',
    replyTo: 'جوابی ای میل پتہ',
    saveBranding: 'برانڈنگ محفوظ کریں',
    brandingSaved: 'برانڈنگ محفوظ ہو گئی',
    domains: 'پورٹل ڈومین',
    domainReadiness:
      'DNS فراہم کنندہ پر TXT ریکارڈ شامل کریں۔ ڈومین فعال ہونے سے پہلے ملکیت، منظور شدہ روٹنگ اور TLS تیار ہوں۔',
    dnsName: 'TXT ریکارڈ نام',
    dnsValue: 'TXT ریکارڈ قدر',
    routing: 'روٹنگ تیار',
    verify: 'DNS کی تصدیق کریں',
    hostname: 'پورٹل ہوسٹ نام',
    addDomain: 'پورٹل ڈومین شامل کریں',
    customAuth:
      'اس پورٹل پر ای میل اور پاس ورڈ استعمال کریں۔ پاس کیز اور سنگل سائن آن کے لیے مرکزی پورٹل پتہ استعمال کریں۔',
    aiUsage: 'AI استعمال',
    managedTokens: 'زیر انتظام ٹوکن استعمال',
    reservedTokens: 'محفوظ زیر انتظام ٹوکن',
    managedCredits: 'زیر انتظام AI کریڈٹ',
    byokTokens: 'اپنی کلید کے ٹوکن',
    creditNote:
      'کریڈٹ اندرونی استعمال کی اکائیاں ہیں، کرنسی نہیں۔ اپنی فراہم کنندہ کلید کے کال الگ شمار ہوتے ہیں۔ محفوظ استعمال فراہم کنندہ رسید کا منتظر ہو سکتا ہے۔',
    appearanceDraftSaved: 'ظاہری مسودہ محفوظ ہو گیا۔ صارف شائع شدہ انداز دیکھتے ہیں۔',
    appearancePublished: 'ویجٹ کا انداز شائع ہو گیا',
    advancedDefinition: 'اعلیٰ ورک فلو تعریف (JSON)',
    applyDefinition: 'تعریف لاگو کریں',
    bindingsHint:
      'queryFrom، requestFrom یا کارروائی بائنڈنگ سے پچھلے نتائج لیں۔ محفوظ کرنے سے پہلے تعریف لاگو کریں؛ سرور حوالہ اور اجازت جانچتا ہے۔',
    stepResult: 'مرحلے کا نتیجہ',
    untrustedResult:
      'حاصل شدہ اور تفویض شدہ مواد غیر معتبر ڈیٹا ہے۔ یہ اجازت یا پالیسی نہیں بدل سکتا۔',
    specialistAgentId: 'داخلی ماہر ایجنٹ شناخت',
    agencyDisabled:
      'ایجنسی موڈ بند ہے۔ اپنی رکنیت والے آزاد کلائنٹ ورک اسپیس بنانے یا لنک کرنے کے لیے فعال کریں۔',
    enableAgency: 'ایجنسی موڈ فعال کریں',
    chatRoute: 'چیٹ چینل',
    permissionPreview: 'WHMCS صارف کی اجازتیں آزمائیں',
    permissionPreviewHint:
      'اس WHMCS صارف اور کلائنٹ اکاؤنٹ کی موجودہ رسائی جانچیں۔ یہ اجازت پڑھتا ہے اور کاروباری کارروائیاں نہیں چلاتا۔',
    whmcsUser: 'WHMCS صارف شناخت',
    whmcsClient: 'WHMCS کلائنٹ شناخت',
    checkPermissions: 'اجازتیں جانچیں',
    permissionsVerified: 'موجودہ اجازتیں تصدیق شدہ۔ ہر کارروائی نیچے دیکھیں۔',
    permissionsUnverified: 'موجودہ اجازتیں تصدیق نہیں ہو سکیں۔ رسائی فرض نہیں کی جاتی۔',
    livePreviewNote:
      'یہ اصل آزمائشی چیٹ ہے۔ مسودے کی تبدیلیاں یہاں نظر آتی ہیں؛ صارف شائع شدہ انداز دیکھتے ہیں۔ دستیابی لائیو چیٹ سروس سے آتی ہے۔',
    closeLivePreview: 'تصویری پیش منظر دکھائیں',
    actionTool: 'کارروائی ٹول',
    specialist: 'ماہر',
    internalSpecialist: 'داخلی ایجنٹ',
    externalSpecialist: 'بیرونی کنکشن',
    unavailableTool: 'ٹول دستیاب نہیں (محفوظ انتخاب)',
    unavailableSpecialist: 'ماہر دستیاب نہیں (محفوظ انتخاب)',
    resourcePickerHint:
      'اس برانڈ کے وہ وسائل دکھتے ہیں جو آپ کا کردار پڑھ سکتا ہے۔ غیر دستیاب محفوظ انتخاب جائزے کے لیے نظر آتے ہیں۔',
    resultPredicateHint:
      'یہ شرط پچھلے مرحلے کے نتیجے کا موازنہ کرتی ہے۔ ماخذ اور موازنہ اعلیٰ ورک فلو تعریف میں تبدیل کریں؛ بنیادی ایڈیٹر اسے محفوظ رکھتا ہے۔',
    manualCoordinatorHint: 'دستی اجرا اس برانڈ کا کوئی فعال، شائع شدہ ایجنٹ استعمال کر سکتے ہیں۔',
    automaticCoordinatorHint:
      'خودکار ورک فلو کے لیے اس برانڈ کا فعال، شائع شدہ ڈیفالٹ جوابی ایجنٹ ضروری ہے۔',
    unavailableCoordinator: 'رابطہ کار دستیاب نہیں (محفوظ انتخاب)',
    stepTypes: {
      trigger: 'آغاز',
      condition: 'شاخ',
      branch: 'شاخ',
      knowledge_lookup: 'معلومات تلاش کریں',
      tool_action: 'کارروائی چلائیں',
      approval: 'منظوری مانگیں',
      wait: 'انتظار',
      delegate: 'ماہر کو سونپیں',
      handoff: 'عملے کو سونپیں',
    },
    fields: {
      event: 'واقعہ',
      hours_open: 'کاروباری اوقات میں',
      signed_in: 'صارف سائن ان',
      country: 'ملک',
      language: 'زبان',
      tag: 'ٹیگ',
    },
    operators: { is: 'ہے', is_not: 'نہیں ہے', contains: 'شامل ہے' },
    budget: {
      maxSteps: 'زیادہ سے زیادہ مراحل',
      maxDelegations: 'زیادہ سے زیادہ تفویض',
      maxDurationSeconds: 'زیادہ سے زیادہ مدت (سیکنڈ)',
      maxDepth: 'زیادہ سے زیادہ تفویض کی گہرائی',
    },
    triggers: {
      manual: 'دستی',
      chat_started: 'چیٹ شروع',
      customer_message: 'صارف پیغام بھیجے',
      chat_closed: 'چیٹ بند',
      offline_message: 'آف لائن پیغام',
    },
    runStates: {
      queued: 'قطار میں',
      running: 'جاری',
      waiting: 'انتظار',
      awaiting_approval: 'منظوری کا انتظار',
      completed: 'مکمل',
      cancelled: 'منسوخ',
      handed_off: 'عملے کے حوالے',
      failed: 'ناکام',
      unknown: 'جائزہ ضروری',
    },
    risks: {
      read: 'معلومات پڑھیں',
      write: 'معلومات تبدیل کرتا ہے',
      money: 'مالی کارروائی',
      irreversible: 'واپس نہیں ہو سکتا',
    },
    approvers: { customer: 'صارف کی منظوری', staff: 'عملے کی منظوری' },
    connectionStates: { active: 'فعال', disabled: 'غیر فعال' },
    domainStates: {
      pending: 'تصدیق باقی',
      verified: 'ملکیت تصدیق شدہ',
      active: 'فعال',
      disabled: 'غیر فعال',
    },
    domainChecks: {
      verified: 'DNS ریکارڈ تصدیق شدہ',
      not_found: 'TXT ریکارڈ نہیں ملا',
      lookup_failed: 'DNS جانچ ناکام؛ دوبارہ آزمائیں',
    },
    permissionReasons: {
      allowed: 'اجازت ہے',
      grant_disabled: 'کارروائی کی اجازت نہیں',
      connection_disabled: 'کنکشن غیر فعال',
      permission_denied: 'صارف کی اجازت مسترد',
      permission_unverified: 'اجازت غیر تصدیق شدہ',
    },
  },
  ar: {
    workflows: 'سير العمل',
    connectors: 'الموصلات',
    advanced: 'إعدادات متقدمة',
    clients: 'عملاء الوكالة',
    directory: 'أدر مساحات عمل العملاء المستقلة. الربط لا يمنح الوصول إلى محتواهم.',
    create: 'إنشاء',
    name: 'الاسم',
    slug: 'عنوان مساحة العمل',
    link: 'ربط مساحة عمل حالية',
    tenantId: 'معرّف مساحة العمل',
    switch: 'فتح مساحة العمل',
    noAccess: 'تلزم عضوية مستقلة',
    unlink: 'إلغاء الربط',
    empty: 'لا توجد عناصر بعد',
    save: 'حفظ المسودة',
    publish: 'نشر',
    pause: 'إيقاف مؤقت',
    resume: 'تفعيل',
    restore: 'استعادة الإصدار',
    test: 'اختبار الاتصال',
    disable: 'تعطيل',
    reconnect: 'إعادة الاتصال',
    status: 'الحالة',
    capabilities: 'الإجراءات المسموحة',
    connectionsDescription:
      'اربط أنظمة العمل واختر إجراءات الوكلاء. تبقى صلاحيات الأدوات وتفويض العميل مطلوبة.',
    baseUrl: 'عنوان WHMCS عبر HTTPS',
    identifier: 'معرّف API',
    secret: 'سر API',
    tools: 'أدوات MCP وHTTP',
    agents: 'الوكلاء الخارجيون',
    credentials: 'تبقى بيانات الاعتماد على الخادم. لا تلصق كلمات مرور العملاء.',
    workflowDescription:
      'أنشئ خطوات محددة وانشر إصدارًا وتابع كل تشغيل. تنتظر خطوات الموافقة شخصًا مخولًا.',
    addStep: 'إضافة خطوة',
    remove: 'إزالة',
    type: 'نوع الخطوة',
    next: 'الخطوة التالية',
    seconds: 'ثواني الانتظار',
    query: 'سؤال المعرفة',
    reason: 'سبب التحويل',
    field: 'حقل العميل',
    value: 'قيمة المطابقة',
    otherwise: 'وإلا',
    toolId: 'معرّف الأداة',
    arguments: 'معاملات الإجراء (JSON)',
    request: 'طلب التفويض',
    connectionId: 'معرّف اتصال الوكيل',
    runs: 'عمليات التشغيل الأخيرة',
    cancel: 'إلغاء التشغيل',
    trigger: 'البدء عند',
    versions: 'الإصدارات',
    unsaved: 'احفظ التغييرات قبل النشر.',
    setup: 'قائمة الإعداد',
    useCase: 'اختر حالة الاستخدام',
    knowledge: 'إضافة معرفة معتمدة',
    permissions: 'ربط الأنظمة ومراجعة الصلاحيات',
    testPublish: 'اختبار ونشر وتثبيت',
    support: 'دعم العملاء',
    lead: 'جمع العملاء المحتملين',
    billing: 'مساعدة الفوترة',
    service: 'تغييرات الخدمة',
    afterhours: 'خارج ساعات العمل',
    handoff: 'التحويل إلى موظف',
    notReady: 'تقدم القائمة لا يضمن الجاهزية. تحقق من المعرفة والصلاحيات واختبار ناجح قبل النشر.',
    livePreview: 'فتح معاينة الودجت الفعلية',
    font: 'الخط',
    launcher: 'تسمية زر المحادثة',
    invalidJson: 'أدخل كائن JSON.',
    coordinator: 'الوكيل المنسق',
    operator: 'المقارنة',
    yes: 'نعم',
    no: 'لا',
    entry: 'الخطوة الأولى',
    budgets: 'حدود التشغيل',
    conversationId: 'معرّف المحادثة',
    startRun: 'بدء التشغيل',
    draft: 'مسودة',
    unsavedChanges: 'تغييرات غير منشورة',
    identityKeyId: 'معرّف مفتاح الهوية الموثق',
    permissionTest:
      'راجع الصلاحيات في الأدوات قبل تفعيل الوكيل. اختبر بالدور وهوية العميل المستخدمين فعليًا.',
    endpoint: 'عنوان الوكيل عبر HTTPS',
    credentialSecretId: 'معرّف سر الاعتماد (اختياري)',
    showBranding: 'إظهار علامة Hamnivo',
    previewSaved: 'تستخدم المعاينة آخر إعدادات محفوظة وتنشئ محادثات اختبار.',
    checkUnknown: 'لم يُفحص',
    checkPresent: 'تم الإعداد',
    checkMissing: 'يحتاج إعدادًا',
    publishedAgent: 'الوكيل الافتراضي المنشور',
    template: 'قالب البداية',
    delegateAllowlist: 'المتخصصون الداخليون المسموحون',
    whenMatched: 'عند المطابقة',
    branding: 'العلامة التجارية',
    brandingDescription: 'خصص البوابة ورسائل العملاء ونطاقات البوابة الموثقة.',
    portal: 'مظهر البوابة',
    favicon: 'رابط أيقونة الموقع HTTPS',
    customerEmail: 'مظهر رسائل العملاء',
    emailLimits:
      'تغير هذه الإعدادات اسم المرسل وعنوان الرد والشعار. يستمر استخدام عنوان إرسال المنصة.',
    senderName: 'اسم المرسل',
    replyTo: 'عنوان البريد للرد',
    saveBranding: 'حفظ العلامة التجارية',
    brandingSaved: 'تم حفظ العلامة التجارية',
    domains: 'نطاقات البوابة',
    domainReadiness:
      'أضف سجل TXT لدى مزود DNS. يلزم إثبات الملكية وتجهيز التوجيه المعتمد وTLS قبل التفعيل.',
    dnsName: 'اسم سجل TXT',
    dnsValue: 'قيمة سجل TXT',
    routing: 'التوجيه جاهز',
    verify: 'التحقق من DNS',
    hostname: 'اسم مضيف البوابة',
    addDomain: 'إضافة نطاق بوابة',
    customAuth:
      'استخدم البريد وكلمة المرور هنا. تستخدم مفاتيح المرور وتسجيل الدخول الموحد عنوان البوابة الأساسي.',
    aiUsage: 'استخدام الذكاء الاصطناعي',
    managedTokens: 'الرموز المدارة المستخدمة',
    reservedTokens: 'الرموز المدارة المحجوزة',
    managedCredits: 'رصيد الذكاء الاصطناعي المدار',
    byokTokens: 'رموز مفتاحك',
    creditNote:
      'الرصيد وحدات استخدام داخلية وليس عملة. تُحسب مكالمات مفتاحك بشكل مستقل. قد ينتظر الاستخدام المحجوز إيصال المزود.',
    appearanceDraftSaved: 'حُفظت مسودة المظهر. يستمر العملاء برؤية المظهر المنشور.',
    appearancePublished: 'تم نشر مظهر الودجت',
    advancedDefinition: 'تعريف سير العمل المتقدم (JSON)',
    applyDefinition: 'تطبيق التعريف',
    bindingsHint:
      'استخدم queryFrom أو requestFrom أو روابط الإجراءات لنتائج الخطوات السابقة. طبق التعريف قبل الحفظ؛ يتحقق الخادم من المراجع والصلاحيات.',
    stepResult: 'نتيجة الخطوة',
    untrustedResult:
      'المحتوى المسترجع والمفوض بيانات غير موثوقة. لا يمنح صلاحيات أو يغير السياسات.',
    specialistAgentId: 'معرّف الوكيل المتخصص الداخلي',
    agencyDisabled: 'وضع الوكالة معطل. فعله لإنشاء أو ربط مساحات عمل عملاء مستقلة بعضويات منفصلة.',
    enableAgency: 'تفعيل وضع الوكالة',
    chatRoute: 'قناة المحادثة',
    permissionPreview: 'اختبار صلاحيات مستخدم WHMCS',
    permissionPreviewHint:
      'يفحص الوصول الحالي لهذا المستخدم وحساب العميل في WHMCS. يقرأ الصلاحيات دون تنفيذ إجراءات العمل.',
    whmcsUser: 'معرّف مستخدم WHMCS',
    whmcsClient: 'معرّف عميل WHMCS',
    checkPermissions: 'فحص الصلاحيات',
    permissionsVerified: 'تم التحقق من الصلاحيات الحالية. راجع كل إجراء أدناه.',
    permissionsUnverified: 'تعذر التحقق من الصلاحيات الحالية. لا يُفترض توفر الوصول.',
    livePreviewNote:
      'هذه محادثة اختبار فعلية. تظهر المسودة هنا ويرى العملاء المظهر المنشور. تأتي حالة التوفر من خدمة المحادثة الفعلية.',
    closeLivePreview: 'إظهار المعاينة المصورة',
    actionTool: 'أداة الإجراء',
    specialist: 'المتخصص',
    internalSpecialist: 'وكيل داخلي',
    externalSpecialist: 'اتصال خارجي',
    unavailableTool: 'الأداة غير متاحة (اختيار محفوظ)',
    unavailableSpecialist: 'المتخصص غير متاح (اختيار محفوظ)',
    resourcePickerHint:
      'يعرض موارد هذه العلامة التي يسمح دورك بقراءتها. تبقى الاختيارات المحفوظة غير المتاحة ظاهرة للمراجعة.',
    resultPredicateHint:
      'يقارن هذا الشرط نتيجة خطوة سابقة. عدل المصدر والمقارنة في التعريف المتقدم؛ يحتفظ المحرر البسيط بها.',
    manualCoordinatorHint: 'يمكن للتشغيل اليدوي استخدام أي وكيل نشط ومنشور لهذه العلامة.',
    automaticCoordinatorHint:
      'تتطلب العمليات التلقائية وكيل الرد الافتراضي النشط والمنشور لهذه العلامة.',
    unavailableCoordinator: 'المنسق غير متاح (اختيار محفوظ)',
    stepTypes: {
      trigger: 'بدء',
      condition: 'تفرع',
      branch: 'تفرع',
      knowledge_lookup: 'بحث المعرفة',
      tool_action: 'تنفيذ إجراء',
      approval: 'طلب موافقة',
      wait: 'انتظار',
      delegate: 'تفويض إلى متخصص',
      handoff: 'تحويل إلى موظف',
    },
    fields: {
      event: 'الحدث',
      hours_open: 'خلال ساعات العمل',
      signed_in: 'العميل مسجل الدخول',
      country: 'البلد',
      language: 'اللغة',
      tag: 'الوسم',
    },
    operators: { is: 'يساوي', is_not: 'لا يساوي', contains: 'يحتوي' },
    budget: {
      maxSteps: 'أقصى عدد خطوات',
      maxDelegations: 'أقصى عدد تفويضات',
      maxDurationSeconds: 'أقصى مدة (ثوانٍ)',
      maxDepth: 'أقصى عمق تفويض',
    },
    triggers: {
      manual: 'يدويًا',
      chat_started: 'بدء المحادثة',
      customer_message: 'إرسال العميل رسالة',
      chat_closed: 'إغلاق المحادثة',
      offline_message: 'رسالة خارج الاتصال',
    },
    runStates: {
      queued: 'في الانتظار',
      running: 'قيد التنفيذ',
      waiting: 'ينتظر',
      awaiting_approval: 'بانتظار الموافقة',
      completed: 'مكتمل',
      cancelled: 'ملغى',
      handed_off: 'تم التحويل لموظف',
      failed: 'فشل',
      unknown: 'يحتاج مراجعة',
    },
    risks: {
      read: 'قراءة المعلومات',
      write: 'يغير المعلومات',
      money: 'إجراء مالي',
      irreversible: 'لا يمكن التراجع',
    },
    approvers: { customer: 'موافقة العميل', staff: 'موافقة الموظف' },
    connectionStates: { active: 'نشط', disabled: 'معطل' },
    domainStates: {
      pending: 'بانتظار التحقق',
      verified: 'تم إثبات الملكية',
      active: 'نشط',
      disabled: 'معطل',
    },
    domainChecks: {
      verified: 'تم التحقق من سجل DNS',
      not_found: 'لم يُعثر على سجل TXT',
      lookup_failed: 'فشل استعلام DNS؛ أعد المحاولة',
    },
    permissionReasons: {
      allowed: 'مسموح',
      grant_disabled: 'الإجراء غير ممنوح',
      connection_disabled: 'الاتصال معطل',
      permission_denied: 'صلاحية المستخدم مرفوضة',
      permission_unverified: 'الصلاحية غير موثقة',
    },
  },
} as const;
